import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { createPageUrl } from '@/utils';
import { Home, Briefcase, MessageSquare, User } from 'lucide-react';

export default function MobileBottomNav({ user }) {
  const location = useLocation();
  
  const isActive = (path) => {
    return location.pathname === path;
  };

  const handleNavClick = (path, e) => {
    // If clicking the already active tab, scroll to top
    if (isActive(path)) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const navItems = user?.user_type === 'worker' ? [
    { icon: Home, label: 'Home', path: "/" },
    { icon: Briefcase, label: 'Applications', path: createPageUrl('WorkerDashboard') },
    { icon: MessageSquare, label: 'Messages', path: createPageUrl('Messages') },
    { icon: User, label: 'Profile', path: createPageUrl('WorkerProfile') },
  ] : [
    { icon: Home, label: 'Home', path: "/" },
    { icon: Briefcase, label: 'Jobs', path: createPageUrl(user?.user_type === 'facility' ? 'FacilityDashboard' : user?.user_type === 'staffing_agency' ? 'StaffingAgencyDashboard' : 'Home') },
    { icon: MessageSquare, label: 'Messages', path: createPageUrl('Messages') },
    { icon: User, label: 'Profile', path: createPageUrl(user?.user_type === 'facility' ? 'FacilityProfile' : user?.user_type === 'staffing_agency' ? 'StaffingAgencyProfile' : 'WorkerProfile') },
  ];

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 bg-white dark:bg-slate-900 border-t border-slate-200 dark:border-slate-800 z-50 pb-safe">
      <div className="grid grid-cols-4 h-16">
        {navItems.map((item) => {
          const Icon = item.icon;
          const active = isActive(item.path);
          
          return (
            <Link
              key={item.label}
              to={item.path}
              onClick={(e) => handleNavClick(item.path, e)}
              className={`flex flex-col items-center justify-center gap-1 select-none transition-colors ${
                active 
                  ? 'text-teal-600 dark:text-teal-400' 
                  : 'text-slate-500 dark:text-slate-400 hover:text-slate-700 dark:hover:text-slate-300'
              }`}
            >
              <Icon className="h-5 w-5" />
              <span className="text-xs font-medium">{item.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}